import * as Yup from "yup";

export const validationSchemaUpdateVehicle = Yup.object().shape({
  vin: Yup.string().required("VIN is required"),
  immatriculation: Yup.string().required("Registration is required"),
  brand: Yup.object().nullable().required("Brand is required"),
  modele: Yup.object().nullable().required("Model is required"),
  gearBox: Yup.string().required("Gearbox is required"),
  fiscalPower: Yup.string().required("Fiscal power is required"),
  energy: Yup.string().required("Fuel type is required"),
  releaseDate: Yup.string().nullable(),
  status: Yup.string().required("Status is required"),
});

export interface FormValuesVehicleUpdate {
  vin: string | null;
  immatriculation: string | null;
  brand: string | null;
  modele: string | null;
  gearBox: string | null;
  fiscalPower: string | null;
  energy: string | null;
  releaseDate: string | null;
  status: string | null;
}

export const initialValuesVehicleUpdate = {
  vin: null,
  immatriculation: null,
  brand: null,
  modele: null,
  gearBox: null,
  fiscalPower: null,
  energy: null,
  releaseDate: null,
  status: null,
} as FormValuesVehicleUpdate;
